// First, so every module after it can call what it defines.
import './polyfills';
import '@fountain/ripple/styles';

import * as Sentry from '@sentry/react';
import { OpenAPI } from 'api-clients/monolith';
import React from 'react';
import { createRoot } from 'react-dom/client';

import { domainMeta } from 'utils/domainMeta';
import { reloadOnChunkLoadError } from 'utils/reloadOnChunkLoadError';
import { initSentry } from 'utils/sentry';
import { guardDomAgainstPageTranslation } from 'utils/translatedDomGuard';

import { getDirection, setBodyDirection } from './direction';
import { Root } from './root';

// Before the first render, so a failure during bootstrap is reported.
initSentry();

reloadOnChunkLoadError(String(process.env.COMMIT_SHA));

guardDomAgainstPageTranslation();

// Load Direction settings
const direction = getDirection();
setBodyDirection(direction);

// Setup OpenApi client
OpenAPI.BASE = domainMeta.monolithOrigin;

const MOUNT_NODE = document.getElementById('app');

// No StrictMode: under createRoot it replays every effect in development, and
// MUI v4's makeStyles detaches its dynamic styles on the replay.
//
// A render error already blanks the portal out, because React unmounts the
// tree it cannot recover. The boundary keeps that behavior — no `fallback`, so
// it renders nothing — and adds the report React does not send.
createRoot(MOUNT_NODE).render(
  <Sentry.ErrorBoundary>
    <Root />
  </Sentry.ErrorBoundary>,
);
